<template>
	<div>
		<ul style="width: 100%;background-color: #FFFFFF;">
			<!-- <tSearch></tSearch> -->
			<!-- 搜索组件 -->
			<newTpSearch :hotState='false'></newTpSearch>
		</ul>
			<div class="main_nav">
				<ul class="text">
					<li class="showHand" @click="jump">首页</li>
					<li>></li>
					<li style="color: #e62129;">消息通知</li>
				</ul>
				<div class="list" v-for="(item,index) in messagenav" :key="index">
					<div class="list_top">
						<div class="list_top_left">
							<p style="margin-right: 10px;">{{item.messageTitle}}</p>
						</div>
						<div class="list_top_ri">
							<p>{{item.newTimeTxt}}</p>
						</div>
					</div>
					<div class="list_bot">
						{{item.messageText}}
					</div>
				</div>
			</div>
	</div>
</template>

<script>
	import newTpSearch from '../../components/newTpSearch.vue'
	import { appCMessageList } from '@/api/comm.js'
	let _self;
	import { fileUpload,appCUserFindById } from '@/api/comm.js'
	import tSearch from "@/components/tSearch.vue"
	export default {
		components: {
			tSearch,
			newTpSearch
		},
		data() {
			return {
				messagenav: null,
				// 接口请求状态
				requestMesState:false,
				// 用户信息
				userInfo:null,
				// 页码
				pageInfo:{
					page:1,
					size:10
				},
			}
		},
		beforeCreate() {
			_self=this;
		},
		created() {
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			if(_self.userInfo){
				// console.log('用户信息==',_self.userInfo);
				// 有用户信息
				_self.handleUpdateUserInfo();
			}
			
			
			// 显示头部导航栏/底部导航栏
			this.$EventBus.$emit('AppCloseNav', true);
			// 获取消息通知列表
			_self.handleGetMessageArr();
		},
		methods: {
			// 更新用户信息
			handleUpdateUserInfo(){
				appCUserFindById({
					userId:_self.userInfo.userId
				}).then(tes=>{
					if(tes.code==200){
						// 接口获取成功
						//定义本地存储的userInfo
						localStorage.setItem('userInfo',JSON.stringify(tes.data))
						// 传递给topBar==用户信息
						_self.$EventBus.$emit('userEditInfo',tes.data)
						// 定义当前用户信息
						_self.$set(_self,'userInfo',tes.data)
					}
				})
			},
			// 获取消息列表
			handleGetMessageArr(){
				appCMessageList({
					..._self.pageInfo,
					userId:_self.userInfo.userId
				}).then(res=>{
					// console.log('消息通知==》接口返回值====》',res);
					
					if(res.data){
						// 定义显示数组
						if(res.data.list && res.data.list.length){
							// 整理后台数据
							let displayArr=[];
							res.data.list.forEach((it,ix)=>{
								// 截取
								it.newTimeTxt=it.messageCreateTime.slice(5,16);
								let newArr=it.newTimeTxt.split(' ');
								let twoTxt=newArr[0].split('-');
								it.newTimeTxt=parseInt(twoTxt[0])+'月'+parseInt(twoTxt[1])+'日'+' '+newArr[1];
								displayArr.push(it);
							})
							
							// 判断页码数
							if(_self.pageInfo.page==1 ){
								_self.messagenav=displayArr;
							}else{
								_self.messagenav=[..._self.messagenav,...displayArr];
							}
						}
						
						
						// 是否允许请求下一页
						_self.requestMesState=res.data.hasNextPage
						
					}else if(_self.pageInfo.page==1){
						// 定义空数组
						_self.messagenav=[];
					}
				})
			},
			// 返回首页
			jump() {
				this.$router.push("/")
			}
		},
		mounted() {
			document.body.style.background='#f5f5f5';
			// 滚动到头部
			window.scrollTo({
			    left: 0,
			    top: 0,
			});
			// 监听页面滑动
			window.onscroll = function(){
				//变量scrollTop是滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
				//变量windowHeight是可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//变量scrollHeight是滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
				// 获取当前页面名称
				let pageName=_self.$router.history.current.name;
				
				//滚动条到底部的条件：  滑动距离+滑块高度大于侧边滚动条长度***最新的滚动条长度不等于上回的高度***允许加载下一页
				if( pageName=='Message' && scrollTop+windowHeight==scrollHeight && _self.requestMesState){
					// 组织频繁请求
					_self.requestMesState=false;
					// 请求下一页
					_self.pageInfo.page++;
					_self.handleGetMessageArr();
				}
			}
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			// next();
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
	}
</script>

<style scoped>
	.main_nav {
		width: 1200px;
		min-height: 750px;
		margin: 0 auto;
		background-color: #F5F5F5;
	}

	.text {
		margin: 25px 0;
		height: 24px;
		font-size: 18px;
		font-weight: 400;
		color: #999999;
		letter-spacing: 2px;
		display: flex;
		flex-direction: row;
	}

	.text li {
		margin-right: 10px;
	}

	.list {
		width: 1200px;
		background-color: #FFFFFF;
		padding: 15px 30px 20px 30px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 10px;
	}

	.list_top {
		width: 1140px;
		margin: 0 auto;
		margin-bottom: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.list_top_left {
		display: flex;
		flex-direction: row;
		align-items: center;
		height: 24px;
		opacity: 1;
		font-size: 18px;
		font-family: Microsoft YaHei, Microsoft YaHei-Bold;
		font-weight: 700;
		text-align: left;
		color: #000000;
		letter-spacing: 1px;
	}

	.status {
		width: 8px;
		height: 8px;
		opacity: 1;
		background: #e62129;
		border-radius: 4px;
	}

	.list_top_ri {
		width: 106px;
		height: 19px;
		opacity: 1;
		font-size: 14px;
		font-family: Microsoft YaHei, Microsoft YaHei-Regular;
		font-weight: 400;
		text-align: right;
		color: #999999;
		letter-spacing: 1px;
	}

	.list_bot {
		width: 100%;
		opacity: 1;
		font-size: 16px;
		font-family: Microsoft YaHei, Microsoft YaHei-Regular;
		font-weight: 400;
		text-align: left;
		color: #333333;
	}
</style>
